import { Box, Typography, Paper } from "@mui/material";
import { MimshakData } from "../../interfaces/DTO/mimshakData";
import { formatCurrency, formatIsoDate } from "../../utils/namesFormater";
import { InsuredType } from "../../interfaces/DTO/mislaka_xml_insurence_models";

interface Props {
  mortgageProduct: MimshakData;
}

export const MiniMortgageLifeInsurance = ({ mortgageProduct }: Props) => {
  // שליפת הנתונים מהמבנה
  const products = mortgageProduct.data?.products || [];
  const firstProduct = products[0];
  const policies = firstProduct?.policies_or_accounts || [];
  const policy = policies[0];

  if (!policy) {
    return null;
  }

  // שליפת סכום הכיסוי
  const coverages = policy.insurence_coverages || [];
  const basicInsurance = coverages.find(c => c.basic_insurance);
  const coverageAmount = basicInsurance?.basic_insurance?.[0]?.insurance_amount;

  // בדיקה האם יש כיסויים למבוטח משני
  const hasSecondaryInsured = coverages.some(
    coverage => coverage.coverage_details?.insured_type === InsuredType.SECONDARY
  );

  // שליפת כל תאריכי הפסקת תשלום מכל ה-coverages
  const paymentStopDates = Array.from(
    new Set(
      coverages
        .map(coverage => coverage.coverage_details?.insurance_fees?.payment_stop_date)
        .filter(date => date !== null && date !== undefined)
    )
  ).sort();

  // חישוב שנים נותרות לכל תאריך
  const datesWithYears = paymentStopDates.map(date => {
    const stopDate = new Date(date);
    const today = new Date();
    const diffTime = stopDate.getTime() - today.getTime();
    const diffYears = diffTime / (1000 * 60 * 60 * 24 * 365.25);
    const yearsRemaining = Math.max(0, Math.round(diffYears * 10) / 10);
    return { date, yearsRemaining };
  });

  // שליפת תאריך פתיחה
  const joinDate = policy.join_date;

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        mb: 3,
        backgroundColor: "#f5f5f5",
        borderRight: "4px solid #E549F0" // צבע משכנתא
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2, color: "#E549F0" }}>
        פרטי ביטוח משכנתא{hasSecondaryInsured ? " +1" : ""}
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {coverageAmount && (
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              סכום כיסוי:
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
              {formatCurrency(coverageAmount)}
            </Typography>
          </Box>
        )}
   {joinDate && (
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              תאריך פתיחה:
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
              {formatIsoDate(joinDate)}
            </Typography>
          </Box>
        )}
        {datesWithYears.length > 0 && (
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              תאריך הפסקת תשלום:
            </Typography>
            {datesWithYears.map((item, index) => (
              <Box key={index} sx={{ mb: index < datesWithYears.length - 1 ? 1 : 0 }}>
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    {formatIsoDate(item.date)}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.5 }}>
                  <Typography variant="caption" sx={{ color: "text.secondary" }}>
                    עוד {item.yearsRemaining} שנים
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        )}



        {policy.policy_number && (
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              מספר פוליסה:
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
              {policy.policy_number}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};
